import useCurrentUser from "@/hooks/useCurrentUser";
import useSWR from "swr";

const fetcher = (url: string) => fetch(url).then((res) => res.json());

export function useAdminStatus() {
  const { currentUser } = useCurrentUser();

  const { data: isUserAdmin } = useSWR(
    currentUser ? "/api/auth/check-role" : null,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      refreshInterval: 5 * 60 * 1000, // 5 minutes
    }
  );

  return { isUserAdmin };
}

export default useAdminStatus;
